import * as z from 'zod';
/**
 * Turn off zod's just-in-time object parser in a BROWSER, before a single schema is built.
 *
 * **The browser refuses `eval` and zod asks anyway.** Section 1.10's `script-src 'self'
 * 'wasm-unsafe-eval'` admits no `'unsafe-eval'`, and zod probes for one: `allowsEval` evaluates
 * `new Function("")` inside a `try`, caches the answer, and falls back to its interpreted parser
 * when the throw comes. Nothing breaks — but the browser reports the attempt as a
 * Content-Security-Policy violation before the throw is swallowed, so every operator who opens a
 * console sees a security error on a page that is behaving correctly. A policy whose violations are
 * all false is a policy nobody reads.
 *
 * The fix is not `'unsafe-eval'`. That would buy back an object-parsing optimisation at the price
 * of the one directive that stops an injected string becoming code.
 *
 * **This lives in the CONTRACT, and the reason is module order.** The probe runs when the FIRST
 * `z.object()` is CONSTRUCTED — not when one is parsed — and the answer is memoised, so the
 * configuration has to be in place before any schema module's body runs. Setting it from the
 * browser's own entry point does NOT achieve that: the bundler hoists this package and zod into a
 * shared chunk that the entry chunk IMPORTS, so the schemas are built before the entry's first
 * statement executes. Measured on a real build — the violation was still reported with
 * `z.config()` as the first line of `main.tsx`. `schemas/common.ts` imports this module first and
 * every schema module imports `common.ts`, which is an order the bundler cannot rearrange.
 *
 * **Two ways to delete this fix without touching this file.** Dropping the `import '../zod-runtime.js'`
 * from `schemas/common.ts`, or adding a module that builds schemas without reaching `common.ts`:
 * `__tests__/zod-runtime.test.ts` walks this package's import graph and refuses both. And adding
 * `"sideEffects": false` to this package's manifest, which would entitle a bundler to drop a bare
 * side-effect import entirely — there is no such field today, and there must not be one.
 *
 * **The SERVER is deliberately left on the JIT path**, which is why this is a condition rather than
 * a bare call: it parses every request body, `new Function` is refused nowhere there, and nothing
 * reports anything. `document` is the test because this package may not touch a Node built-in and
 * must not read `process`; the browser and the `web` tier's jsdom have one, the api, the worker and
 * the CLI do not.
 */
if (typeof globalThis.document !== 'undefined') {
    z.config({ jitless: true });
}
//# sourceMappingURL=zod-runtime.js.map